import {calculateAngle} from '../utils/calculateAngle.js';

export function calculateArrowPointOnLineString(
    linecoordinates,
    placement = 'end',
    toRight = true,
    foreachSegment = false
) {

    const points = [];
    const angles = [];

    if (foreachSegment == false) {

        var end = linecoordinates[linecoordinates.length - 1];
        var start = linecoordinates[linecoordinates.length - 2];

        if (!toRight) {
            end = linecoordinates[0];
            start = linecoordinates[1];
        }

        var coord1 = end[0],
            coord2 = end[1];

        if (placement == 'start') {
            coord1 = start[0];
            coord2 = start[1];
        } else if (placement == 'mid') {
            coord1 = (start[0] + end[0]) / 2;
            coord2 = (start[1] + end[1]) / 2;
        }

        const angle = -calculateAngle(start, end);
        angles.push(angle);
        points.push([coord1, coord2]);

    } else {

        for (let i = 0; i < linecoordinates.length - 1; i++) {
            var start = linecoordinates[i];
            var end = linecoordinates[i + 1];

            if (!toRight) {
                end = linecoordinates[linecoordinates.length - i - 2];
                start = linecoordinates[linecoordinates.length - i - 1];
            }

            var coord1 = end[0],
                coord2 = end[1];

            if (placement == 'start') {
                coord1 = start[0];
                coord2 = start[1];
            } else if (placement == 'mid') {
                coord1 = (start[0] + end[0]) / 2;
                coord2 = (start[1] + end[1]) / 2;
            }

            const angle = -calculateAngle(start, end);
            angles.push(angle);
            points.push([coord1, coord2]);
        }

    }

    return {points: points, angles: angles};
}
